var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',[_vm._v("Edit User")]),_c('v-container',[_c('UserForm',{attrs:{"dbUser":_vm.dbUser,"umUser":_vm.umUser,"type":"UPDATE"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }